module.exports = __webpack_public_path__ + "img/img2.1d39f051.png";